export default {
    "loginForm.title": " შესვლა",
    "loginForm.fields.email.label": "ელ.ფოსტა",
    "loginForm.fields.password.label": "პაროლი",
    "loginForm.buttons.login.title": "შესვლა",
    "loginForm.errors.unableLogin": " შეცდომა. გთხოვთ სცადოთ მოგვიანებით.",
    "loginForm.fields.forgotPassword.label": "დაგავიწყდათ პაროლი?",

    "accountRecoveryInitiate.title": "დაგავიწყდათ პაროლი?",
    "accountRecoveryInitiate.buttons.restore.title": "აღდგენა",
    "accountRecoveryInitiate.buttons.back.title": "უკან",
    "accountRecoveryInitiate.fields.email.label": "ელ.ფოსტა",
    "accountRecoveryInitiate.errors.unableRecovery": "შეცდომა პაროლის აღდგენაში. გთხოვთ, სცადოთ მოგვიანებით",
    "accountRecoveryInitiate.events.emailSentSuccess": "ანგარიშის აღდგენის ელ.ფოსტა წარმატებით გაიგზავნა",
    "accountRecoveryInitiate.hint.nextAttemptAfter": "კიდევ სცადეთ",
    "accountRecoveryInitiate.description": "გაგზავნეთ შესვლის ბმული თქვენს ელ.ფოსტაზე",

    "accountRecoveryFinish.title": "პაროლის პარამეტრები",
    "accountRecoveryFinish.errors.unableRecovery": "შეცდომა ანგარიშის აღდგენაში. გთხოვთ, სცადოთ მოგვიანებით.",
    "accountRecoveryFinish.hint.enterPasswordForAccount": "შეიყვანეთ ახალი პაროლი თქვენი ანგარიშისთვის",
    "accountRecoveryFinish.buttons.tryAgain.title": "კიდევ სცადეთ",
    "accountRecoveryFinish.fields.password.label": "პაროლი",
    "accountRecoveryFinish.fields.password.hint": "პაროლი უნდა შეიცავდეს სულ მცირე ერთ ციფრს და მინიმუმ 8 სიმბოლოს",
    "accountRecoveryFinish.fields.confirmPassword.label": "პაროლის დადასტურება",
    "accountRecoveryFinish.buttons.restore.title": "აღდგენა",
    "accountRecoveryFinish.validation.passwordMaxLength": " პაროლი არ უნდა აღემატებოდეს 72 სიმბოლოს ",
    "accountRecoveryFinish.validation.passwordMinLength": "პაროლი არ უნდა იყოს 8 სიმბოლოზე ნაკლები",
    "accountRecoveryFinish.validation.noPassword": "შეიყვანეთ პაროლი",
    "accountRecoveryFinish.validation.noConfirmPassword": "შეიყვანეთ პაროლი დასადასტურებლად",
    "accountRecoveryFinish.validation.passwordsMismatch": "პაროლები არ ემთხვევა ერთმანეთს",
    "accountRecoveryFinish.notification.accountRecovered": "ანგარიშზე წვდომა წარმატებით აღდგა! გამოიყენეთ ახალი პაროლი თქვენს პირად ანგარიშში შესასვლელად",

    "invite.title": "ანგარიშის შექმნის დასრულება",
    "invite.fields.password.label": "პაროლი",
    "invite.fields.password.hint": "პაროლი უნდა შეიცავდეს სულ მცირე ერთ ციფრს და მინიმუმ 8 სიმბოლოს",
    "invite.fields.confirmPassword.label": "პაროლის დადასტურება",
    "invite.errors.unableRecovery": "შედომაა ანგარიშის დასრულებაში. გთხოვთ, სცადოთ მოგვიანებით.",
    "invite.validation.passwordMaxLength": " პაროლი არ უნდა აღემატებოდეს 72 სიმბოლოს ",
    "invite.validation.passwordMinLength": "პაროლი არ უნდა იყოს 8 სიმბოლოზე ნაკლები",
    "invite.validation.noPassword": "შეიყვანეთ პაროლი",
    "invite.validation.noConfirmPassword": "შეიყვანეთ პაროლი დასადასტურებლად",
    "invite.validation.passwordsMismatch": "პაროლები არ ემთხვევა ერთმანეთს",
    "invite.hint.enterPasswordForAccount": "გთხოვთ შეიყვანოთ პაროლი თქვენი ანგარიშისთვის",
    "invite.buttons.confirm.title": " დადასტურება ",
    "invite.notification.accountConfirmed": "თქვენ წარმატებით დაასრულეთ ანგარიშის რეგისტრაცია! გამოიყენეთ მითითებული პაროლი თქვენს პირად ანგარიშში შესასვლელად",
    "common.close": "დახურვა",

    "fg.components.footer.contactEmailDescription": "ყველა შეკითხვისთვის მოგვწერეთ მეილზე",
    "kromos.components.footer.contactEmailDescription": "ყველა შეკითხვისთვის მოგვწერეთ მეილზე",
    "fg.components.footer.contactEmail": "lab@f-genetics.com",
    "kromos.components.footer.contactEmail": "lab@kromos.ge",
    "fg.components.footer.yearSince": "2020",
    "kromos.components.footer.yearSince": "2022",
    "fg.components.footer.company": "f-genetics.com",
    "kromos.components.footer.company": "kromos.ge",

}